import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useDeviceType } from "../../../customHooks/useDeviceType";

import "./table-view.m.css";

export const TableView = ({ topmostValueCelebritiesList, visibleItemsForList, columns, currentView, subcolumns }) => {

  const isMobile = useDeviceType() !== "desktop";
  const scrollContainerRef = useRef(null);
  const tableRef = useRef(null);
  const [expandedCards, setExpandedCards] = useState({});

  const toggleReadMore = (index) => {
  setExpandedCards((prev) => ({
    ...prev,
    [index]: !prev[index],
  }));
};

  return (
    <div styleName="tableWrapper">
      <div styleName="tableContainer" ref={scrollContainerRef}>
        <div styleName="ranking-cards-wrapper" ref={tableRef}>
          {topmostValueCelebritiesList?.map((celeb, index) => (
          <div styleName="ranking-cards" key={index}>
            <div styleName="ranking-photo"><img src={`${celeb?.image_link}?w=480&auto=format,compress&q=80`} alt={celeb?.brand} title={celeb?.brand} width="250" height="250" /></div>
            <div styleName="ranking-content">
              {celeb?.rank &&<span styleName="num-value">{celeb?.rank}</span>}
              {celeb?.brand && <div styleName="ranking-celeb-name">{celeb?.brand}</div>}
              {celeb?.sector && <span styleName="sector">{celeb?.sector}</span>}
              <p styleName={`traits ${expandedCards[index] ? "expanded" : ""}`}>{celeb?.traits_that_make_them_valuable} <button type="button"
                  styleName="read-more-btn" onClick={() => toggleReadMore(index)}>{expandedCards[index] ? "" : "...read more"}</button></p>
              {celeb?.highest_scores_on &&
              <div styleName="scores">
                <span styleName="tag-head">Highest scores on</span>
                {celeb.highest_scores_on
                  ?.split(",")
                  .map((score, index) => (
                    <span styleName="tag" key={index}>
                      {score.trim()}
                    </span>
                  ))}
              </div>
              }
            </div>
            <div styleName="rail">
              {celeb?.rank &&<span styleName="rk">Rank {celeb?.rank}</span>}
              <div styleName="value">₹{celeb?.brand_value_cr}<span>cr</span><small>Brand value</small>
              </div>
            </div>
          </div>
          ))}
        </div>
      </div>
    </div>
  );
};

TableView.propTypes = {
  topmostValueCelebritiesList: PropTypes.arrayOf(PropTypes.object).isRequired,
  visibleItemsForList: PropTypes.number.isRequired,
};
